import React from "react"
import { StaticImage } from "gatsby-plugin-image"

const Info = () => {
  return (
   <>
   <div className ="info-bg">
    {/*   <StaticImage
        src="../assets/images/bg-1.png"
        alt="info-background"
        className="info-img"
        placeholder="tracedSVG"
      />   */}
      <div className=" section section-center ">
        <div className="row">
         <div className="col">
            <h4 className= "pre-title">About me</h4>
            <h2 className="text-large">
              A passionate web developer focusing on front-end interactive
              experiences.
            </h2>
          </div>
          <div className="col">
            <h4 className="pre-title">Lets talk</h4>
            <p className="text-medium">
              I design and code beautiful, simple things, and I love what I do.
              If you're a business looking to hire or seeking a web presence, or
              if you wish to collaborate on a project, contact me.
            </p>
          </div>
        </div>
      </div>
      </div>
      
      </>
  )
}

export default Info
